import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import ElementsDataService from '../../api/entitiesDataServices/ElementsDataService.js'
import AuthenticationService from '../general/AuthenticationService.js'
import parse from 'html-react-parser'

const PAGE_SIZE = 30

class DocumentoComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            elements: [],
            count: 0,
            pagenumber: 0,
            allSociedades: [],
            sociedadFiltro: null,
            socSearch: '',
            showSocDropdown: false,
            busqueda: '',
            loading: true,
            loadingMore: false,
            ...props,
        }
        this.goBusqueda = this.goBusqueda.bind(this)
        this.handleScroll = this.handleScroll.bind(this)
    }

    componentDidMount() {
        if (!AuthenticationService.haveAuthorization("READ_DOCUMENTOS")) {
            alert("Usuario no autorizado")
            this.props.history.push('/login')
            return
        }
        this.loadInitial()
        ElementsDataService.retrieveAllElements("sociedades")
            .then(r => this.setState({
                allSociedades: r.data.map(s => ({ id: s.id, razonSocial: s.razonSocial, rfc: s.rfc }))
            }))
        window.addEventListener('scroll', this.handleScroll, { passive: true })
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    }

    loadInitial() {
        this.setState({ loading: true })
        ElementsDataService.retrieveAllElements("documentosCount")
            .then(r => {
                this.setState({ count: r.data })
                return ElementsDataService.retrieveAllElements("documentosPaginated?pageNumber=0&size=30")
            })
            .then(r => this.setState({ elements: r.data, pagenumber: 0, loading: false }))
    }

    handleScroll() {
        const { loadingMore, pagenumber, count, busqueda, sociedadFiltro } = this.state
        if (loadingMore || busqueda || sociedadFiltro) return
        const nearBottom = window.innerHeight + document.documentElement.scrollTop >= document.scrollingElement.scrollHeight - 100
        if (!nearBottom) return
        const nextPage = pagenumber + 1
        if (nextPage * PAGE_SIZE >= count) return
        this.setState({ loadingMore: true })
        ElementsDataService.retrieveAllElements(`documentosPaginated?pageNumber=${nextPage}&size=30`)
            .then(r => this.setState(prev => ({
                elements: prev.elements.concat(r.data),
                pagenumber: nextPage,
                loadingMore: false,
            })))
    }

    goBusqueda() {
        const q = this.state.busqueda.toUpperCase()
        if (q.length < 3) {
            alert("Debe escribir al menos tres caracteres.")
            return
        }
        this.setState({ loading: true, sociedadFiltro: null, socSearch: '' })
        ElementsDataService.retrieveSearch(q, "documentos")
            .then(r => {
                if (!r.data.length) alert("Esta búsqueda no arroja resultados.")
                this.setState({ elements: r.data, loading: false })
                window.removeEventListener('scroll', this.handleScroll)
            })
    }

    clearBusqueda() {
        this.setState({ busqueda: '' })
        this.loadInitial()
        window.addEventListener('scroll', this.handleScroll, { passive: true })
    }

    selectSociedad(soc) {
        this.setState({ sociedadFiltro: soc, socSearch: '', showSocDropdown: false, loading: true, busqueda: '' })
        ElementsDataService.retrieveElement("getDocumentosSociedad", soc.id)
            .then(r => {
                this.setState({ elements: r.data, loading: false })
                window.removeEventListener('scroll', this.handleScroll)
            })
    }

    clearSociedad() {
        this.setState({ sociedadFiltro: null, socSearch: '' })
        this.loadInitial()
        window.addEventListener('scroll', this.handleScroll, { passive: true })
    }

    highlight(text) {
        const q = this.state.busqueda
        if (!text || q.length < 3) return text
        return parse(text.replace(new RegExp(q, 'gi'), m => `<mark style="background:#dbeafe;color:#1d4ed8;border-radius:3px;padding:0 2px">${m}</mark>`))
    }

    render() {
        const { elements, allSociedades, sociedadFiltro, socSearch, showSocDropdown,
            busqueda, loading, loadingMore, count } = this.state

        const filteredSocs = allSociedades.filter(s =>
            (s.razonSocial + ' ' + s.rfc).toLowerCase().includes(socSearch.toLowerCase())
        )

        const tipoBadgeColor = (tipo) => {
            if (!tipo) return { bg: '#f1f5f9', color: '#64748b', border: '#e2e8f0' }
            const t = tipo.toUpperCase()
            if (t.includes('ACTA')) return { bg: '#eff6ff', color: '#2563eb', border: '#bfdbfe' }
            if (t.includes('CONTRATO')) return { bg: '#f0fdf4', color: '#16a34a', border: '#bbf7d0' }
            if (t.includes('PODER')) return { bg: '#fff7ed', color: '#c2410c', border: '#fed7aa' }
            if (t.includes('FISCAL') || t.includes('SAT')) return { bg: '#fefce8', color: '#ca8a04', border: '#fef08a' }
            if (t.includes('NOTARIAL')) return { bg: '#f5f3ff', color: '#7c3aed', border: '#ddd6fe' }
            return { bg: '#f1f5f9', color: '#475569', border: '#e2e8f0' }
        }

        return (
            <div style={S.root}>
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
                    .doc-root * { font-family: 'Inter', sans-serif; box-sizing: border-box; }
                    .doc-input {
                        width: 100%; padding: 9px 14px;
                        background: white; border: 1px solid #e2e8f0; border-radius: 10px;
                        font-size: 0.875rem; color: #334155; outline: none; transition: all 0.2s;
                        font-family: 'Inter', sans-serif;
                    }
                    .doc-input:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
                    .doc-th {
                        padding: 9px 14px; text-align: left; font-size: 0.68rem; font-weight: 700;
                        color: #64748b; letter-spacing: 0.7px; text-transform: uppercase;
                        border-bottom: 1px solid #e2e8f0; background: #f8fafc; white-space: nowrap;
                    }
                    .doc-tr { border-bottom: 1px solid #f1f5f9; transition: background 0.15s; }
                    .doc-tr:hover td { background: #f8faff !important; }
                    .doc-td { padding: 10px 14px; font-size: 0.82rem; color: #334155; vertical-align: top; }
                    .doc-link { color: #3b82f6; text-decoration: none; font-weight: 600; }
                    .doc-link:hover { text-decoration: underline; }
                    .doc-soc-link { color: #475569; text-decoration: none; font-size: 0.78rem; display: block; padding: 1px 0; }
                    .doc-soc-link:hover { color: #3b82f6; }
                    .btn-edit { padding: 4px 9px; border: 1px solid #e2e8f0; border-radius: 7px; background: white; cursor: pointer; font-size: 0.72rem; color: #64748b; transition: all 0.15s; }
                    .btn-edit:hover { border-color: #3b82f6; color: #3b82f6; background: #eff6ff; }
                    .btn-del { padding: 4px 9px; border: 1px solid #fee2e2; border-radius: 7px; background: white; cursor: pointer; font-size: 0.72rem; color: #ef4444; transition: all 0.15s; }
                    .btn-del:hover { background: #fef2f2; border-color: #ef4444; }
                    .soc-item { padding: 9px 14px; cursor: pointer; font-size: 0.82rem; color: #334155; transition: background 0.15s; border-bottom: 1px solid #f8fafc; }
                    .soc-item:hover { background: #eff6ff; color: #2563eb; }
                    @keyframes fadeIn { from { opacity:0; transform:translateY(4px) } to { opacity:1; transform:none } }
                    .doc-fade { animation: fadeIn 0.25s ease; }
                    @keyframes spin { to { transform: rotate(360deg); } }
                    .spinner { width: 28px; height: 28px; border: 3px solid #e2e8f0; border-top-color: #3b82f6; border-radius: 50%; animation: spin 0.7s linear infinite; }
                    .chip-soc {
                        display: inline-flex; align-items: center; gap: 6px;
                        background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 20px;
                        padding: 5px 12px 5px 10px; font-size: 0.8rem; color: #2563eb; font-weight: 600;
                    }
                    .chip-soc button { background: #bfdbfe; border: none; border-radius: 50%; width: 16px; height: 16px; cursor: pointer; color: #1d4ed8; font-size: 0.6rem; display: flex; align-items: center; justify-content: center; }
                    .chip-soc button:hover { background: #ef4444; color: white; }
                `}</style>

                <div className="doc-root" style={S.inner}>

                    {/* Header */}
                    <div style={S.header}>
                        <div>
                            <h1 style={S.title}>Documentos</h1>
                            <p style={S.subtitle}>
                                {loading ? 'Cargando...' : `${elements.length}${!busqueda && !sociedadFiltro ? ` de ${count}` : ''} documento${elements.length !== 1 ? 's' : ''}`}
                            </p>
                        </div>
                        {AuthenticationService.haveAuthorization("WRITE_DOCUMENTOS") && (
                            <button style={S.btnAdd} onClick={this.props.addElementClicked}>+ Documento</button>
                        )}
                    </div>

                    {/* Barra búsqueda + filtro sociedad */}
                    <div style={S.searchCard}>
                        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                            {/* Buscador texto */}
                            <div style={{ flex: 2, minWidth: 200, position: 'relative' }}>
                                <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', fontSize: '0.85rem', pointerEvents: 'none' }}>🔍</span>
                                <input
                                    className="doc-input"
                                    style={{ paddingLeft: 36, paddingRight: busqueda ? 36 : 14 }}
                                    type="text"
                                    placeholder="Buscar por tipo, asunto, sociedad... (Enter)"
                                    value={busqueda}
                                    onChange={e => this.setState({ busqueda: e.target.value.toUpperCase() })}
                                    onKeyDown={e => { if (e.key === 'Enter') this.goBusqueda() }}
                                />
                                {busqueda && (
                                    <button onClick={() => this.clearBusqueda()} style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', fontSize: '1rem' }}>✕</button>
                                )}
                            </div>

                            {/* Filtro sociedad */}
                            <div style={{ flex: 1, minWidth: 200, position: 'relative' }}>
                                {sociedadFiltro ? (
                                    <div className="chip-soc" style={{ height: 39, width: '100%', justifyContent: 'space-between' }}>
                                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>🏢 {sociedadFiltro.razonSocial}</span>
                                        <button onClick={() => this.clearSociedad()}>✕</button>
                                    </div>
                                ) : (
                                    <>
                                        <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', fontSize: '0.85rem', pointerEvents: 'none' }}>🏢</span>
                                        <input
                                            className="doc-input"
                                            style={{ paddingLeft: 36 }}
                                            type="text"
                                            placeholder="Filtrar por sociedad..."
                                            value={socSearch}
                                            onChange={e => this.setState({ socSearch: e.target.value, showSocDropdown: true })}
                                            onFocus={() => this.setState({ showSocDropdown: true })}
                                            onBlur={() => setTimeout(() => this.setState({ showSocDropdown: false }), 150)}
                                        />
                                        {showSocDropdown && socSearch.length > 0 && (
                                            <div style={{ position: 'absolute', top: '110%', left: 0, right: 0, background: 'white', border: '1px solid #e2e8f0', borderRadius: 10, zIndex: 100, maxHeight: 200, overflowY: 'auto', boxShadow: '0 8px 24px rgba(0,0,0,0.1)' }}>
                                                {filteredSocs.length === 0
                                                    ? <div style={{ padding: '12px 14px', color: '#94a3b8', fontSize: '0.8rem' }}>Sin resultados</div>
                                                    : filteredSocs.slice(0, 30).map(s => (
                                                        <div key={s.id} className="soc-item" onMouseDown={() => this.selectSociedad(s)}>
                                                            <div style={{ fontWeight: 600 }}>{s.razonSocial}</div>
                                                            <div style={{ fontSize: '0.7rem', color: '#94a3b8', fontFamily: 'monospace' }}>{s.rfc}</div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>

                            <button style={S.btnSearch} onClick={this.goBusqueda}>Buscar</button>
                        </div>
                    </div>

                    {/* Tabla */}
                    <div style={S.tableCard}>
                        {loading ? (
                            <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}>
                                <div className="spinner" />
                            </div>
                        ) : (
                            <div style={{ overflowX: 'auto' }} className="doc-fade">
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr>
                                            <th className="doc-th" style={{ width: 44, textAlign: 'center' }}>#</th>
                                            <th className="doc-th">Sociedades</th>
                                            <th className="doc-th" style={{ minWidth: 130 }}>Tipo Documento</th>
                                            <th className="doc-th">Asuntos</th>
                                            <th className="doc-th" style={{ minWidth: 100 }}>Fecha</th>
                                            {AuthenticationService.haveAuthorization("WRITE_DOCUMENTOS") && <th className="doc-th" style={{ width: 40 }}></th>}
                                            {AuthenticationService.haveAuthorization("DELETE_DOCUMENTOS") && <th className="doc-th" style={{ width: 40 }}></th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {elements.length === 0 ? (
                                            <tr><td colSpan={7} style={{ textAlign: 'center', padding: '48px 0', color: '#94a3b8', fontSize: '0.85rem' }}>
                                                Sin resultados. Prueba con otro término o filtro.
                                            </td></tr>
                                        ) : elements.map((el, i) => {
                                            const c = tipoBadgeColor(el.tipoDocumento)
                                            return (
                                                <tr key={el.id} className="doc-tr">
                                                    <td className="doc-td" style={{ textAlign: 'center', color: '#94a3b8', fontWeight: 600, fontSize: '0.78rem' }}>{i + 1}</td>
                                                    <td className="doc-td" style={{ maxWidth: 220 }}>
                                                        {el.sociedades?.map(s => (
                                                            <Link key={s.id} to={`/sociedades/reportes/${s.id}`} className="doc-soc-link">
                                                                {this.highlight(s.razonSocial)}
                                                            </Link>
                                                        ))}
                                                    </td>
                                                    <td className="doc-td">
                                                        <Link to={`/documentos/reportes/${el.id}`} style={{ textDecoration: 'none' }}>
                                                            <span style={{ fontSize: '0.72rem', fontWeight: 700, padding: '3px 10px', borderRadius: 20, background: c.bg, color: c.color, border: `1px solid ${c.border}`, whiteSpace: 'nowrap', display: 'inline-block' }}>
                                                                {el.tipoDocumento || '—'}
                                                            </span>
                                                        </Link>
                                                    </td>
                                                    <td className="doc-td" style={{ maxWidth: 320 }}>
                                                        <Link to={`/documentos/reportes/${el.id}`} className="doc-link" style={{ fontWeight: 500, color: '#334155' }}>
                                                            {this.highlight(el.asuntos || el.tipoDocumento || '—')}
                                                        </Link>
                                                    </td>
                                                    <td className="doc-td" style={{ whiteSpace: 'nowrap', fontSize: '0.78rem', color: '#64748b' }}>{el.fecha || '—'}</td>
                                                    {AuthenticationService.haveAuthorization("WRITE_DOCUMENTOS") && (
                                                        <td className="doc-td" style={{ textAlign: 'center' }}>
                                                            <button className="btn-edit" onClick={() => this.props.updateElementClicked(el.id)}>✏️</button>
                                                        </td>
                                                    )}
                                                    {AuthenticationService.haveAuthorization("DELETE_DOCUMENTOS") && (
                                                        <td className="doc-td" style={{ textAlign: 'center' }}>
                                                            <button className="btn-del" onClick={() => this.props.deleteElementClicked(el.id)}>🗑</button>
                                                        </td>
                                                    )}
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>

                                {/* Load more indicator */}
                                {loadingMore && (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10, padding: '16px 0', color: '#94a3b8', fontSize: '0.8rem' }}>
                                        <div className="spinner" style={{ width: 18, height: 18, borderWidth: 2 }} />
                                        Cargando más documentos...
                                    </div>
                                )}
                                {!loadingMore && !busqueda && !sociedadFiltro && elements.length > 0 && elements.length >= count && (
                                    <div style={{ textAlign: 'center', padding: '14px 0', color: '#94a3b8', fontSize: '0.78rem', borderTop: '1px solid #f1f5f9' }}>
                                        ✓ Todos los documentos cargados ({count})
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

const S = {
    root: { minHeight: '100vh', background: '#f1f5f9', padding: '28px', fontFamily: "'Inter', sans-serif" },
    inner: { maxWidth: 1100, margin: '0 auto' },
    header: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 20, flexWrap: 'wrap', gap: 12 },
    title: { margin: '0 0 4px', fontSize: '1.5rem', fontWeight: 700, color: '#0f172a' },
    subtitle: { margin: 0, fontSize: '0.82rem', color: '#94a3b8' },
    btnAdd: { padding: '9px 16px', background: 'linear-gradient(135deg, #2563eb, #3b82f6)', border: 'none', borderRadius: 10, color: 'white', fontWeight: 600, fontSize: '0.84rem', cursor: 'pointer', boxShadow: '0 4px 12px rgba(59,130,246,0.3)', fontFamily: "'Inter', sans-serif" },
    btnSearch: { padding: '9px 18px', background: '#0f172a', border: 'none', borderRadius: 10, color: 'white', fontWeight: 600, fontSize: '0.84rem', cursor: 'pointer', fontFamily: "'Inter', sans-serif", whiteSpace: 'nowrap' },
    searchCard: { background: 'white', border: '1px solid #e8edf5', borderRadius: 16, padding: '16px 20px', marginBottom: 14, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' },
    tableCard: { background: 'white', border: '1px solid #e8edf5', borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' },
}

export default DocumentoComponent
